/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import { connect } from "react-redux";
import BusApiCall from "../../../helper/axios";
import Loader from "../../../component/loader";
import actionTypes from "../../../store/actions";
import React, { Component, useRef } from "react";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Axios from "axios";
import Breadcrumb from "../../../component/breadcrumb";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Grid,
  Paper,
  InputLabel,
  Select,
  FormControl,
  Checkbox,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import Input from "../../../component/inputpm";
import Button from "../../../component/button";
import { Tooltip } from "@mui/material";
import Delete from "@mui/icons-material/Delete";
import { xml2json, json2xml, js2xml, xml2js } from "xml-js";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Draggable from "react-draggable";
import { EditIconNew, ViewIconNew } from "../../../component/icons/icons";
import TableContainer from "@mui/material/TableContainer";
// import { withStyles } from '@mui/styles';
class ProductOfferingRules extends Component {
  // Declare property values that belongs to the component
  state = {
    loading: true,
    bread: [
      {
        title: this.props.t("PRODUCT_OFFERING_RULES"),
        url: "/productOfferingRules",
      },
    ],
    offerings: [],
    ruleRowProxy: [],
    rules: [],
    demographicsOptionsList: [],
    data: {},
    originalData: null,
    editable: false,
    selectedOfferingDialog: false,
    selectedRuleToShow: {},
    selectedRuleOfferings: [],
    selectedRuleIndex: null,
    tenantId: "",
    render: false,
  };

  componentDidMount() {
    this.getRulesData();
    if (this.props.tenantInfo && this.props.tenantInfo.tenantId) {
      this.setState({
        tenantId: this.props.tenantInfo.tenantId,
      });
    } else {
      this.setState({
        tenantId: this.props.tenantId,
      });
    }
  }

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  getRulesData = () => {
    this.setState({
      render: false,
    });
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/product/filters?filterType=productOfferingRules`,
    )
      .then((res) => {
        this.setState(
          {
            demographicsOptionsList: res.data.sort((a, b) =>
              a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
            ),
          },
          () => {
            var ruleRowProxy = {};
            for (
              var i = 0;
              i < this.state.demographicsOptionsList.length;
              i++
            ) {
              ruleRowProxy[
                "inputEntry_" +
                this.state.demographicsOptionsList[i].id +
                "-operator"
              ] = "==";
              ruleRowProxy[
                "inputEntry_" +
                this.state.demographicsOptionsList[i].id +
                "-expression"
              ] = "";
            }
            ruleRowProxy["outputEntry_productOffering"] = [];
            ruleRowProxy["outputEntry_ruleName"] = "";
            this.setState({
              ruleRowProxy,
            });
            BusApiCall(
              "GET",
              `${constants.busInternalUrl2}/productOfferings/eligibilityRules`,
            )
              .then((res) => {
                if (res.data.code === "200") {
                  var resContent = JSON.parse(atob(res.data.jsonResponse64));
                  var xmlData = atob(resContent.dmnTableContent);
                  var tableContent = xml2js(xmlData, { compact: true });
                  if (
                    tableContent &&
                    tableContent.definitions &&
                    tableContent.definitions.decision
                  ) {
                    if (
                      tableContent.definitions.decision._attributes.id.includes(
                        this.state.tenantId,
                      )
                    ) {
                    } else {
                      tableContent.definitions.decision._attributes.id =
                        tableContent.definitions.decision._attributes.id +
                        "_" +
                        this.state.tenantId;
                      tableContent.definitions.decision._attributes.name =
                        tableContent.definitions.decision._attributes.name +
                        " - " +
                        this.state.tenantId;
                    }
                  }
                  this.setState(
                    {
                      originalData: JSON.stringify(tableContent),
                      data: tableContent,
                    },
                    () => {
                      BusApiCall(
                        "GET",
                        `${constants.busV44Url}/productOfferings`,
                      )
                        .then((solRes) => {
                          var allOfferings = solRes.data;
                          var filteredOfferings = [];
                          for (var i = 0; i < allOfferings.length; i++) {
                            if (!allOfferings[i].categoryIds.includes("PKG")) {
                              filteredOfferings.push(allOfferings[i]);
                            }
                          }
                          var demographicsOptionsList = [
                            ...this.state.demographicsOptionsList,
                          ];
                          demographicsOptionsList.push({
                            name: "Product Offering",
                            id: "productOffering",
                            entries: filteredOfferings,
                            output: true,
                          });
                          var rules = this.state.data.definitions.decision
                            .decisionTable.rule
                            ? this.state.data.definitions.decision.decisionTable
                              .rule
                            : [];
                          var formatedRules = [];
                          if (Array.isArray(rules)) {
                            for (var i = 0; i < rules.length; i++) {
                              var rule = {};
                              var inputs = rules[i].inputEntry;
                              if (Array.isArray(inputs)) {
                                for (var j = 0; j < inputs.length; j++) {
                                  var jid = inputs[j]._attributes.id.substr(
                                    0,
                                    inputs[j]._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[jid + "-operator"] = inputs[
                                    j
                                  ].text._cdata
                                    .split('"')[0]
                                    .trim();
                                  rule[jid + "-expression"] =
                                    inputs[j].text._cdata.split('"')[1];
                                }
                              } else {
                                if (inputs) {
                                  var jid = inputs._attributes.id.substr(
                                    0,
                                    inputs._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[jid + "-operator"] = inputs.text._cdata
                                    .split('"')[0]
                                    .trim();
                                  rule[jid + "-expression"] =
                                    inputs.text._cdata.split('"')[1];
                                }
                              }
                              var outputs = rules[i].outputEntry;
                              if (Array.isArray(outputs)) {
                                for (var k = 0; k < outputs.length; k++) {
                                  if (
                                    outputs[k]._attributes.id.includes(
                                      "productOffering",
                                    )
                                  ) {
                                    var kid = outputs[k]._attributes.id.substr(
                                      0,
                                      outputs[k]._attributes.id.lastIndexOf(
                                        "_",
                                      ),
                                    );
                                    rule[kid] = [];
                                    rule[kid].push(
                                      JSON.parse(outputs[k].text._cdata),
                                    );
                                  } else {
                                    var kid = outputs[k]._attributes.id.substr(
                                      0,
                                      outputs[k]._attributes.id.lastIndexOf(
                                        "_",
                                      ),
                                    );
                                    rule[kid] = JSON.parse(
                                      outputs[k].text._cdata,
                                    );
                                  }
                                }
                              } else {
                                if (
                                  outputs._attributes.id.includes(
                                    "productOffering",
                                  )
                                ) {
                                  var kid = outputs._attributes.id.substr(
                                    0,
                                    outputs._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[kid] = [];
                                  rule[kid].push(
                                    JSON.parse(outputs.text._cdata),
                                  );
                                } else {
                                  var kid = outputs._attributes.id.substr(
                                    0,
                                    outputs._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[kid] = JSON.parse(outputs.text._cdata);
                                }
                              }
                              for (var d in this.state
                                .demographicsOptionsList) {
                                if (
                                  rule.hasOwnProperty(
                                    "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-operator",
                                  )
                                ) {
                                } else {
                                  rule[
                                    "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-operator"
                                  ] = "==";
                                }
                                if (
                                  rule.hasOwnProperty(
                                    "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-expression",
                                  )
                                ) {
                                } else {
                                  rule[
                                    "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-expression"
                                  ] = "";
                                }
                              }
                              formatedRules.push(rule);
                            }
                          } else {
                            var rule = {};
                            if (rules && rules.inputEntry) {
                              var inputs = rules.inputEntry;
                              if (Array.isArray(inputs)) {
                                for (var j = 0; j < inputs.length; j++) {
                                  var jid = inputs[j]._attributes.id.substr(
                                    0,
                                    inputs[j]._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[jid + "-operator"] = inputs[
                                    j
                                  ].text._cdata
                                    .split('"')[0]
                                    .trim();
                                  rule[jid + "-expression"] =
                                    inputs[j].text._cdata.split('"')[1];
                                }
                              } else {
                                var jid = inputs._attributes.id.substr(
                                  0,
                                  inputs._attributes.id.lastIndexOf("_"),
                                );
                                rule[jid + "-operator"] = inputs.text._cdata
                                  .split('"')[0]
                                  .trim();
                                rule[jid + "-expression"] =
                                  inputs.text._cdata.split('"')[1];
                              }
                            }
                            if (rules && rules.outputEntry) {
                              var outputs = rules.outputEntry;
                              for (var k = 0; k < outputs.length; k++) {
                                if (
                                  outputs[k]._attributes.id.includes(
                                    "productOffering",
                                  )
                                ) {
                                  var kid = outputs[k]._attributes.id.substr(
                                    0,
                                    outputs[k]._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[kid] = [];
                                  rule[kid].push(
                                    JSON.parse(outputs[k].text._cdata),
                                  );
                                } else {
                                  var kid = outputs[k]._attributes.id.substr(
                                    0,
                                    outputs[k]._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[kid] = JSON.parse(
                                    outputs[k].text._cdata,
                                  );
                                }
                              }
                              for (var d in this.state
                                .demographicsOptionsList) {
                                if (
                                  rule.hasOwnProperty(
                                    "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-operator",
                                  )
                                ) {
                                } else {
                                  rule[
                                    "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-operator"
                                  ] = "==";
                                }
                                if (
                                  rule.hasOwnProperty(
                                    "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-expression",
                                  )
                                ) {
                                } else {
                                  rule[
                                    "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-expression"
                                  ] = "";
                                }
                              }
                            }
                            formatedRules.push(rule);
                          }
                          const result = [];
                          for (const obj of formatedRules) {
                            let trigger_new = true;
                            for (const resObj of result) {
                              let trigger_not_equals_keys = true;
                              for (const resKey in resObj)
                                for (const key in obj) {
                                  if (
                                    resKey !== "outputEntry_productOffering" &&
                                    key !== "outputEntry_productOffering" &&
                                    resKey === key &&
                                    resObj[resKey] !== obj[key]
                                  )
                                    trigger_not_equals_keys = false;
                                }
                              if (trigger_not_equals_keys) {
                                trigger_new = false;
                                if (
                                  Array.isArray(
                                    resObj.outputEntry_productOffering,
                                  )
                                ) {
                                  var index =
                                    resObj.outputEntry_productOffering.findIndex(
                                      (x) =>
                                        x ===
                                        obj.outputEntry_productOffering[0],
                                    );
                                  if (index === -1) {
                                    resObj.outputEntry_productOffering.push(
                                      obj.outputEntry_productOffering[0],
                                    );
                                  }
                                } else {
                                  resObj.outputEntry_productOffering = [
                                    resObj.outputEntry_productOffering,
                                    obj.outputEntry_productOffering,
                                  ];
                                }
                              }
                            }
                            if (trigger_new) result.push(obj);
                          }
                          this.setState(
                            {
                              offerings: filteredOfferings,
                              demographicsOptionsList,
                            },
                            () => {
                              this.setState({
                                rules: result,
                                loading: false,
                                render: true,
                              });
                            },
                          );
                        })
                        .catch((err) => {
                          if (
                            err.response &&
                            err.response.data &&
                            err.response.data.message
                          ) {
                            this.props.setErrorMessage(
                              err.response.data.message,
                              false,
                            );
                          } else {
                            this.props.setErrorMessage(
                              this.props.t("DEFAULT_ERROR_MESSAGE"),
                              false,
                            );
                          }
                          this.setState({ loading: false, render: true });
                        });
                    },
                  );
                } else {
                  this.setState({ loading: false, render: true });
                  this.setInitialRulesData();
                }
              })
              .catch((err) => {
                this.setInitialRulesData();
              });
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          render: true,
        });
      });
  };

  setInitialRulesData = () => {
    var tempData = {
      definitions: {
        _attributes: {
          xmlns: "https://www.omg.org/spec/DMN/20191111/MODEL/",
          "xmlns:dmndi": "https://www.omg.org/spec/DMN/20191111/DMNDI/",
          "xmlns:dc": "http://www.omg.org/spec/DMN/20180521/DC/",
          "xmlns:di": "http://www.omg.org/spec/DMN/20180521/DI/",
          id: "definition_ac383ec0-59c5-11ed-9c2b-16375c7f29fb",
          name: "Cumulator Product Offering Rules",
          namespace: "http://www.flowable.org/dmn",
          exporter: "Flowable Open Source Modeler",
          exporterVersion: "6.7.2",
        },
        decision: {
          _attributes: {
            id: "CumulatorProductOfferingRules_" + this.state.tenantId,
            name: "Cumulator Product Offering Rules - " + this.state.tenantId,
          },
          description: {
            _text: "Cumulator Product Offering Rules",
          },
          decisionTable: {
            _attributes: {
              id: "decisionTable_0d306d80-af44-48ba-81cb-38944fd36c78",
              hitPolicy: "COLLECT",
            },
            input: [],
            output: [
              {
                _attributes: {
                  id: "outputExpression_productOffering",
                  label: "Product Offering",
                  name: "Product Offering",
                  typeRef: "string",
                },
                outputValues: {
                  text: {
                    _text: '""',
                  },
                },
              },
              {
                _attributes: {
                  id: "outputExpression_ruleName",
                  label: "Rule Name",
                  name: "Rule Name",
                  typeRef: "string",
                },
                outputValues: {
                  text: {
                    _text: '""',
                  },
                },
              },
            ],
            rule: [],
          },
        },
        "dmndi:DMNDI": {},
      },
    };
    BusApiCall("GET", `${constants.busV44Url}/productOfferings`)
      .then((solRes) => {
        var allOfferings = solRes.data;
        var filteredOfferings = [];
        for (var i = 0; i < allOfferings.length; i++) {
          if (!allOfferings[i].categoryIds.includes("PKG")) {
            filteredOfferings.push(allOfferings[i]);
          }
        }
        var demographicsOptionsList = [...this.state.demographicsOptionsList];
        demographicsOptionsList.push({
          name: "Product Offering",
          id: "productOffering",
          entries: filteredOfferings,
          output: true,
        });
        this.setState({
          offerings: filteredOfferings,
          demographicsOptionsList,
          data: tempData,
          editable: true,
          loading: false,
          render: true,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false, render: true });
      });
  };

  setInputType = (val) => {
    if (val === "string") {
      return "text";
    } else if (val === "number") {
      return "number";
    } else if (val === "date") {
      return "date";
    } else if (val === "collection") {
      return "text";
    } else {
      return "text";
    }
  };

  createTableData = () => {
    this.setState({
      loading: true,
    });
    var payload = { ...this.state.data };

    var finalInputs = [];
    var demographics = this.state.demographicsOptionsList;
    for (var i = 0; i < demographics.length; i++) {
      if (demographics[i].id !== "productOffering") {
        var options = [];
        var ruleInputText = "";
        if (demographics[i].entries) {
          for (var j = 0; j < demographics[i].entries.length; j++) {
            options.push('\"' + demographics[i].entries[j].id + '\"');
          }
        }
        var input = {
          _attributes: {
            label: demographics[i].name,
          },
          inputExpression: {
            _attributes: {
              id: "inputExpression_" + demographics[i].id,
              typeRef: "string",
            },
            text: {
              _text: demographics[i].id,
            },
          },
          inputValues: {
            text: {
              _text: options.join(),
            },
          },
        };
        finalInputs.push(input);
      }
    }

    var tempRules = JSON.parse(JSON.stringify(this.state.rules));
    var finalRules = [];
    var count = 1;
    console.log("RETURNED RULES:", tempRules);
    for (var i = 0; i < tempRules.length; i++) {
      if (!tempRules[i]["outputEntry_ruleName"].trim()) {
        this.props.setErrorMessage(
          this.props.t("RULE_NAME_IS_REQUIRED"),
          false,
        );
        this.setState({
          loading: false,
          render: true,
        });
        return;
      }
      if (
        tempRules[i]["outputEntry_productOffering"] &&
        tempRules[i]["outputEntry_productOffering"].length > 0
      ) {
        for (
          var k = 0;
          k < tempRules[i]["outputEntry_productOffering"].length;
          k++
        ) {
          var rule = {
            inputEntry: [],
            outputEntry: [],
          };
          for (var j = 0; j < this.state.demographicsOptionsList.length; j++) {
            if (
              this.state.demographicsOptionsList[j].id === "productOffering"
            ) {
              rule.outputEntry.push({
                _attributes: { id: "outputEntry_productOffering_" + count },
                text: {
                  _cdata:
                    '\"' +
                    tempRules[i]["outputEntry_productOffering"][k] +
                    '\"',
                },
              });
            } else {
              var expVal =
                tempRules[i][
                "inputEntry_" +
                this.state.demographicsOptionsList[j].id +
                "-expression"
                ];
              if (expVal) {
                if (expVal == "-1") {
                  rule.inputEntry.push({
                    _attributes: {
                      id:
                        "inputEntry_" +
                        this.state.demographicsOptionsList[j].id +
                        "_" +
                        count,
                    },
                    text: {
                      _cdata:
                        "${" +
                        this.state.demographicsOptionsList[j].id +
                        '.contains(\"\")}',
                    },
                  });
                } else {
                  rule.inputEntry.push({
                    _attributes: {
                      id:
                        "inputEntry_" +
                        this.state.demographicsOptionsList[j].id +
                        "_" +
                        count,
                    },
                    text: {
                      _cdata:
                        "==" +
                        ' \"' +
                        tempRules[i][
                        "inputEntry_" +
                        this.state.demographicsOptionsList[j].id +
                        "-expression"
                        ] +
                        '\"',
                    },
                  });
                }
              } else {
                if (this.state.demographicsOptionsList[j].entries) {
                  rule.inputEntry.push({
                    _attributes: {
                      id:
                        "inputEntry_" +
                        this.state.demographicsOptionsList[j].id +
                        "_" +
                        count,
                    },
                    text: {
                      _cdata:
                        "${" +
                        this.state.demographicsOptionsList[j].id +
                        '.contains(\"\")}',
                    },
                  });
                } else {
                  rule.inputEntry.push({
                    _attributes: {
                      id:
                        "inputEntry_" +
                        this.state.demographicsOptionsList[j].id +
                        "_" +
                        count,
                    },
                    text: { _cdata: "-" },
                  });
                }
              }
            }
          }
          rule.outputEntry.push({
            _attributes: { id: "outputEntry_ruleName_" + count },
            text: {
              _cdata: '\"' + tempRules[i]["outputEntry_ruleName"] + '\"',
            },
          });
          count++;
          finalRules.push(rule);
        }
      } else {
        var rule = {
          inputEntry: [],
          outputEntry: [],
        };
        for (var j = 0; j < this.state.demographicsOptionsList.length; j++) {
          if (this.state.demographicsOptionsList[j].id === "productOffering") {
            rule.outputEntry.push({
              _attributes: { id: "outputEntry_productOffering_" + count },
              text: { _cdata: '\"\"' },
            });
          } else {
            if (
              tempRules[i][
              "inputEntry_" +
              this.state.demographicsOptionsList[j].id +
              "-expression"
              ]
            ) {
              rule.inputEntry.push({
                _attributes: {
                  id:
                    "inputEntry_" +
                    this.state.demographicsOptionsList[j].id +
                    "_" +
                    count,
                },
                text: {
                  _cdata:
                    tempRules[i][
                    "inputEntry_" +
                    this.state.demographicsOptionsList[j].id +
                    "-operator"
                    ] +
                    ' \"' +
                    tempRules[i][
                    "inputEntry_" +
                    this.state.demographicsOptionsList[j].id +
                    "-expression"
                    ] +
                    '\"',
                },
              });
            }
          }
        }
        rule.outputEntry.push({
          _attributes: { id: "outputEntry_ruleName_" + count },
          text: {
            _cdata: '\"' + tempRules[i]["outputEntry_ruleName"] + '\"',
          },
        });
        count++;
        finalRules.push(rule);
      }
    }
    payload.definitions.decision.decisionTable.input = finalInputs;
    payload.definitions.decision.decisionTable.rule = [...finalRules];
    payload.definitions.decision.decisionTable._attributes.id =
      "decisionTable_0d306d80-af44-48ba-81cb-38944fd36c78";
    console.log("POSTED RULES", payload);
    this.submitTableData(payload);
  };

  submitTableData = (payload) => {
    var xmlData = js2xml(payload, { compact: true });
    var finalPayload = {
      dmnTableContent: btoa(xmlData),
    };
    BusApiCall(
      "POST",
      `${constants.busInternalUrl2}/productOfferings/eligibilityRules`,
      finalPayload,
    )
      .then((res) => {
        this.props.setErrorMessage("Data updated successfully", true);
        this.getRulesData();
        this.setState({
          editable: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false, render: true });
      });
  };

  addRule = () => {
    var ruleRowProxy = { ...this.state.ruleRowProxy };
    var rules = JSON.parse(JSON.stringify(this.state.rules));
    rules.push(ruleRowProxy);
    this.setState({
      rules,
    });
  };

  onChangeRule = (e, i, item) => {
    var rules = JSON.parse(JSON.stringify(this.state.rules));
    rules[i][e.target.name] = e.target.value;
    this.setState({
      rules,
    });
  };

  removeRule = (rule, index) => {
    var rules = JSON.parse(JSON.stringify(this.state.rules));
    rules.splice(index, 1);
    this.setState({
      rules,
    });
  };

  changeOfferingSelection = (id) => {
    var rules = JSON.parse(JSON.stringify(this.state.rules));
    var index = rules[this.state.selectedRuleIndex][
      "outputEntry_productOffering"
    ].findIndex((x) => x === id);
    if (index > -1) {
      rules[this.state.selectedRuleIndex]["outputEntry_productOffering"].splice(
        index,
        1,
      );
    } else {
      rules[this.state.selectedRuleIndex]["outputEntry_productOffering"].push(
        id,
      );
    }
    this.setState({
      rules,
    });
  };

  editRulesTable = () => {
    this.setState({
      editable: true,
    });
  };

  cancelUpdate = () => {
    this.setState({
      loading: true,
      editable: false,
    });
    this.getRulesData();
  };

  showSelectedOfferings = (rule, list, index) => {
    var tempList = [];
    if (list && list.length > 0) {
      tempList = list.filter((x) => x && x);
    } else {
      tempList = [];
    }
    this.setState({
      selectedOfferingDialog: true,
      selectedRuleToShow: rule,
      selectedRuleOfferings: tempList ? tempList : [],
      selectedRuleIndex: index,
    });
  };

  closeShowOfferings = () => {
    this.setState({
      selectedOfferingDialog: false,
      selectedRuleToShow: {},
      selectedRuleOfferings: [],
      selectedRuleIndex: null,
    });
  };

  render() {
    const { t } = this.props;
    const { classes: jssClasses } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main
          style={{
            width: "100%",
            maxWidth: "calc(100% - 70px)",
            paddingTop: 0,
          }}
        >
          {this.state.render && (
            <>
              <Paper className="tablePaper" elevation={0}>
                {(this.props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                  this.props.userPerms.includes("CATALOG_CREATE") ||
                  this.props.userPerms.includes("CATALOG_ADMIN")) && (
                    <>
                      {this.state.editable ? (
                        <div
                          align={"right"}
                          className="global-custom-pagination"
                          style={{ paddingTop: "10px" }}
                        >
                          <Button onClick={() => this.addRule()}>
                            {t("NEW_RULE")}
                          </Button>
                        </div>
                      ) : (
                        <div align={"right"} className="global-custom-pagination">
                          <Button
                            className="buttonSecondary"
                            onClick={() => this.editRulesTable()}
                          >
                            <span>
                              <EditIconNew />
                            </span>
                            {t("EDIT")}
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                <div style={{ overflow: "auto" }}>
                  <TableContainer>
                    <Table className="newGlobalTable">
                      <TableHead>
                        <TableRow>
                          <TableCell>{t("RULE_NAME") + " *"}</TableCell>
                          {this.state.demographicsOptionsList.map(
                            (item, index) =>
                              item.id === "productOffering" ? (
                                <React.Fragment key={index}>
                                  <TableCell align={"center"}>
                                    {item.name}
                                  </TableCell>
                                </React.Fragment>
                              ) : (
                                <React.Fragment key={index}>
                                  <TableCell key={index}>{item.name}</TableCell>
                                </React.Fragment>
                              ),
                          )}
                          {this.state.editable && <TableCell></TableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.rules &&
                          this.state.rules.map((rule, rIndex) => (
                            <TableRow key={rIndex}>
                              <TableCell>
                                {this.state.editable ? (
                                  <Input
                                    name={"outputEntry_ruleName"}
                                    style={{ width: "175px" }}
                                    value={rule["outputEntry_ruleName"]}
                                    onChange={(event) =>
                                      this.onChangeRule(event, rIndex)
                                    }
                                  />
                                ) : (
                                  <>{rule["outputEntry_ruleName"]}</>
                                )}
                              </TableCell>
                              {this.state.demographicsOptionsList.map(
                                (item) => (
                                  <React.Fragment key={item.id}>
                                    {this.state.editable ? (
                                      <>
                                        {item.output ? (
                                          <TableCell align="center">
                                            <Tooltip
                                              title={t("ADD_OFFERINGS")}
                                              onClick={() =>
                                                this.showSelectedOfferings(
                                                  rule,
                                                  rule[
                                                  "outputEntry_" + item.id
                                                  ],
                                                  rIndex,
                                                )
                                              }
                                              style={{
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                              }}
                                            >
                                              <AddCircleIcon />
                                            </Tooltip>
                                          </TableCell>
                                        ) : (
                                          <>
                                            <TableCell>
                                              {item.entries &&
                                                item.entries.length > 0 &&
                                                item.dataType === "collection" ? (
                                                <FormControl
                                                  style={{ width: "175px" }}
                                                  variant="outlined"
                                                  size={"small"}
                                                  className={
                                                    "customeSelectLabel"
                                                  }
                                                >
                                                  <Select
                                                    value={
                                                      rule[
                                                      "inputEntry_" +
                                                      item.id +
                                                      "-expression"
                                                      ]
                                                    }
                                                    native
                                                    onChange={(event) =>
                                                      this.onChangeRule(
                                                        event,
                                                        rIndex,
                                                        item,
                                                      )
                                                    }
                                                    inputProps={{
                                                      name:
                                                        "inputEntry_" +
                                                        item.id +
                                                        "-expression",
                                                      id:
                                                        "inputEntry_" +
                                                        item.id +
                                                        "-expression",
                                                    }}
                                                  >
                                                    {item.entries.map(
                                                      (entry, e) => (
                                                        <option
                                                          key={e}
                                                          value={entry.id}
                                                        >
                                                          {entry.name}
                                                        </option>
                                                      ),
                                                    )}
                                                  </Select>
                                                </FormControl>
                                              ) : (
                                                <>
                                                  <Input
                                                    name={
                                                      "inputEntry_" +
                                                      item.id +
                                                      "-expression"
                                                    }
                                                    id={
                                                      "inputEntry_" +
                                                      item.id +
                                                      "-expression"
                                                    }
                                                    value={
                                                      rule[
                                                      "inputEntry_" +
                                                      item.id +
                                                      "-expression"
                                                      ]
                                                    }
                                                    variant={"outlined"}
                                                    onChange={(event) =>
                                                      this.onChangeRule(
                                                        event,
                                                        rIndex,
                                                        item,
                                                      )
                                                    }
                                                    // placeholder={t('NAME') + ' *'}
                                                    size={"small"}
                                                    style={{ width: "175px" }}
                                                  />
                                                </>
                                              )}
                                            </TableCell>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {item.output ? (
                                          <TableCell align="center">
                                            <Tooltip
                                              title={t("VIEW_OFFERINGS")}
                                              onClick={() => {
                                                this.showSelectedOfferings(
                                                  rule,
                                                  rule[
                                                  "outputEntry_" + item.id
                                                  ],
                                                  rIndex,
                                                );
                                              }}
                                            >
                                              <IconButton className="buttonSecondary">
                                                <ViewIconNew />
                                              </IconButton>
                                              {/* <VisibilityIcon /> */}
                                            </Tooltip>
                                          </TableCell>
                                        ) : (
                                          <TableCell>
                                            {item.entries &&
                                              item.entries.length > 0 &&
                                              item.dataType === "collection" ? (
                                              <>
                                                {rule[
                                                  "inputEntry_" +
                                                  item.id +
                                                  "-expression"
                                                ]
                                                  ? item.entries.map(
                                                    (entry, e) =>
                                                      entry.id ===
                                                      rule[
                                                      "inputEntry_" +
                                                      item.id +
                                                      "-expression"
                                                      ] && entry.name,
                                                  )
                                                  : "Dont Care"}
                                              </>
                                            ) : (
                                              <>
                                                {
                                                  rule[
                                                  "inputEntry_" +
                                                  item.id +
                                                  "-expression"
                                                  ]
                                                }
                                              </>
                                            )}
                                          </TableCell>
                                        )}
                                      </>
                                    )}
                                  </React.Fragment>
                                ),
                              )}
                              {this.state.editable &&
                                (this.props.userPerms.includes(
                                  "CATALOG_ADMIN_ALL",
                                ) ||
                                  this.props.userPerms.includes(
                                    "CATALOG_CREATE",
                                  ) ||
                                  this.props.userPerms.includes(
                                    "CATALOG_ADMIN",
                                  )) && (
                                  <TableCell align="right">
                                    <Tooltip title={t("DELETE")}>
                                      <Delete
                                        onClick={() => {
                                          this.removeRule(rule, rIndex);
                                        }}
                                      />
                                    </Tooltip>
                                  </TableCell>
                                )}
                            </TableRow>
                          ))}
                        {this.state.rules && this.state.rules.length === 0 && (
                          <TableRow>
                            <TableCell
                              colSpan={
                                this.state.demographicsOptionsList.length + 1
                              }
                              align="center"
                            >
                              {t("NO_RULES_DEFINED")}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                {this.state.editable &&
                  (this.props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                    this.props.userPerms.includes("CATALOG_CREATE") ||
                    this.props.userPerms.includes("CATALOG_ADMIN")) && (
                    <div align={"right"} className="global-custom-pagination">
                      <Button onClick={() => this.cancelUpdate()}>
                        {t("CANCEL")}
                      </Button>
                      <Button
                        style={{ marginLeft: 15 }}
                        onClick={() => this.createTableData()}
                      >
                        {t("SAVE")}
                      </Button>
                    </div>
                  )}
              </Paper>
              {this.state.selectedOfferingDialog && (
                <Dialog
                  disableScrollLock={true}
                  maxWidth={"md"}
                  PaperComponent={this.draggableDialogPaper}
                  fullWidth={true}
                  open={this.state.selectedOfferingDialog}
                  aria-labelledby="delete-dialog-title"
                  PaperProps={
                    {
                      // className: jssClasses.resizablePaper
                    }
                  }
                >
                  <DialogTitle
                    id="draggableDialogPaper"
                    style={{ cursor: "move" }}
                  >
                    {t("RULE")}{" "}
                    {this.state.selectedRuleToShow["outputEntry_ruleName"]}:{" "}
                    {t("PRODUCT_OFFERINGS")}
                  </DialogTitle>
                  <DialogContent dividers>
                    <Paper className="tablePaper" elevation={0}>
                      <TableContainer>
                        <Table className="newGlobalTable">
                          <TableBody>
                            {this.state.editable ? (
                              <>
                                {this.state.offerings.map((item, i) => (
                                  <TableRow key={i}>
                                    <TableCell>
                                      <FormControlLabel
                                        style={{ marginLeft: 0 }}
                                        control={
                                          <Checkbox
                                            checked={this.state.rules[
                                              this.state.selectedRuleIndex
                                            ][
                                              "outputEntry_productOffering"
                                            ].includes(item.productId)}
                                            onChange={() =>
                                              this.changeOfferingSelection(
                                                item.productId,
                                              )
                                            }
                                            name={"outputEntry_productOffering"}
                                          />
                                        }
                                        label={
                                          item.productName +
                                          " [" +
                                          item.productId +
                                          "]"
                                        }
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </>
                            ) : (
                              <>
                                {this.state.offerings.map((item, i) =>
                                  this.state.selectedRuleOfferings.map(
                                    (id, r) =>
                                      item.productId === id && (
                                        <TableRow key={i}>
                                          <TableCell className="text-body"
                                          >
                                            {item.productName}{" "}
                                            {"[" + item.productId + "]"}
                                          </TableCell>
                                        </TableRow>
                                      ),
                                  ),
                                )}
                                {(this.state.selectedRuleOfferings.length ===
                                  0 ||
                                  this.state.selectedRuleOfferings[0] ===
                                  "") && (
                                    <TableRow>
                                      <TableCell
                                        className="text-body"
                                        style={{
                                          textAlign: "center",
                                        }}
                                      >
                                        {t("NO_OFFERINGS_ADDED")}
                                      </TableCell>
                                    </TableRow>
                                  )}
                              </>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={(event) => this.closeShowOfferings(false)}
                      color="primary"
                    >
                      {this.state.editable ? t("CANCEL") : t("CLOSE")}
                    </Button>
                    {this.state.editable &&
                      (this.props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                        this.props.userPerms.includes("CATALOG_CREATE") ||
                        this.props.userPerms.includes("CATALOG_ADMIN")) && (
                        <Button
                          onClick={(event) => this.closeShowOfferings(true)}
                          color="primary"
                        >
                          {t("SAVE")}
                        </Button>
                      )}
                  </DialogActions>
                </Dialog>
              )}
            </>
          )}
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

// const styles = {

//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     },
// };

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
    userPerms: state.auth.userPerms,
    tenantInfo: state.auth.tenantInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ProductOfferingRules));
